import {
    FaHome,
    FaTools,
    FaBriefcase,
    FaComments,
    FaPhoneAlt,
    FaEnvelope,
    FaMapMarkerAlt,
    FaFileAlt,
    FaShieldAlt,
    FaBolt,
    FaCog,
    FaFacebookF,
    FaInstagram,
    FaLinkedinIn,
    FaTwitter,
  } from 'react-icons/fa';
  
  export default function Footer() {
    return (
      <footer className="bg-white pt-16 pb-6 px-4 w-full">
        <div className="max-w-6xl mx-auto flex flex-col">
          {/* Main Content */}
          <div className="flex flex-col md:flex-row gap-8 justify-between">
            {/* Logo and Description */}
            <div className="flex flex-col">
              <img className="w-32 h-32 mb-4 mx-auto" src="assets/img/logo.png" alt="Logo" />
              <p className="text-sm text-gray-600">
                Empowering Industries & Homes with <br /> Smart & Sustainable Electric Services.
              </p>
            </div>
  
            {/* Links Sections */}
            <div className="md:w-3/5 grid grid-cols-1 sm:grid-cols-3 gap-10">
              {/* Quick Links */}
              <div>
                <h3 className="text-lg font-bold mb-4">Quick Links</h3>
                <ul className="space-y-3 text-sm text-gray-700">
                  <li className="flex items-center gap-2 hover:text-blue-600 cursor-pointer">
                    <FaHome /> Home
                  </li>
                  <li className="flex items-center gap-2 hover:text-blue-600 cursor-pointer">
                    <FaTools /> Services
                  </li>
                  <li className="flex items-center gap-2 hover:text-blue-600 cursor-pointer">
                    <FaBriefcase /> Projects
                  </li>
                  <li className="flex items-center gap-2 hover:text-blue-600 cursor-pointer">
                    <FaComments /> Testimonials
                  </li>
                  <li className="flex items-center gap-2 hover:text-blue-600 cursor-pointer">
                    <FaPhoneAlt /> Contact Us
                  </li>
                  <li className="flex items-center gap-2 hover:text-blue-600 cursor-pointer">
                    <FaFileAlt /> Company Profile
                  </li>
                </ul>
              </div>
  
              {/* Why Us */}
              <div>
                <h3 className="text-lg font-bold mb-4">Why Us?</h3>
                <ul className="space-y-3 text-sm text-gray-700">
                  <li className="flex items-center gap-2">
                    <FaShieldAlt /> Safety Inspection
                  </li>
                  <li className="flex items-center gap-2">
                    <FaBolt /> Electric Installation
                  </li>
                  <li className="flex items-center gap-2">
                    <FaCog /> Best Maintenance
                  </li>
                </ul>
  
                {/* Social Media Icons */}
                <div className="flex gap-4 mt-6 text-blue-600">
                  <a href="https://www.facebook.com/alabbaselectricengineering/" aria-label="Facebook" className="bg-black p-1.5 text-white rounded-md hover:text-blue-800">
                    <FaFacebookF size={20} />
                  </a>
                  <a href="#" aria-label="Twitter" className="bg-black p-1.5 text-white rounded-md hover:text-blue-500">
                    <FaTwitter size={20} />
                  </a>
                  <a href="https://www.instagram.com/alabbaselectricengineering/" aria-label="Instagram" className="bg-black p-1.5 text-white rounded-md hover:text-pink-500">
                    <FaInstagram size={20} />
                  </a>
                  <a href="#" aria-label="LinkedIn" className="bg-black p-1.5 text-white rounded-md hover:text-blue-700">
                    <FaLinkedinIn size={20} />
                  </a>
                </div>
              </div>
  
              {/* Contact */}
              <div>
                <h3 className="text-lg font-bold mb-4">Contact</h3>
                <ul className="space-y-3 text-sm text-gray-700">
                  <li className="flex items-center gap-2">
                    <FaPhoneAlt /> +92 340 4849 424
                  </li>
                  <li className="flex items-center gap-2">
                    <FaPhoneAlt /> 0213 4901 717
                  </li>
                  <li className="flex items-center gap-2">
                    <FaEnvelope /> info@alabbaselectric.com
                  </li>
                  <li className="flex items-start gap-2">
                    <FaMapMarkerAlt className="mt-1" />
                    <span>
                      Office No.25, Plot No.S-22/B & S-22/D,
                      <br />
                      Malir Cantt Bazar Area, Karachi
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
  
          {/* Copyright */}
          <div className="mt-10 pt-6 border-t border-gray-200 text-center text-sm text-gray-600">
            © 2025 Al Abbas Electric Engineering. All Rights Reserved.
          </div>
        </div>
      </footer>
    );
  }
  